module.exports = __webpack_public_path__ + "assets/img/100401.80d5ba83.png";